import React from "react";
import WhoAmI from "./WhoAmI";

export default function GroupCheck(props) {
  return (
    <React.Suspense fallback="">
      <WhoAmI groupName={props.groupName}>{props.children}</WhoAmI>
    </React.Suspense>
  );
}
